import { IpaType } from "../phonemes/ipa";

type Ignore = (item: string) => boolean;

/** replace ipa[i - i+length] with 'replace',
 * if anything in the section being replaced is ignorable, use it without being fancy */
export function replace(ipa: IpaType[], i: number, length: number, replace: IpaType[], ignore?: Ignore): IpaType[] {
  const pre: IpaType[] = ipa.slice(0, i)
  const ignorable = getIgnorable(ipa, i, length, ignore);
  const post = ipa.slice(i + length + ignorable.length);
  return pre.concat(ignorable).concat(replace).concat(post);
}

/** return [number of items being replaced, new content] */
export function getReplacement(
  ipa: IpaType[], i: number, length: number, replace: IpaType[], ignore?: Ignore
): [number, IpaType[]] {
  const ignorable = getIgnorable(ipa, i, length, ignore);
  const beingReplaced = length + ignorable.length;
  return [beingReplaced, ignorable.concat(replace)];
}

function getIgnorable(ipa: IpaType[], i: number, length: number, ignore?: Ignore): IpaType[] {
  if (!ignore) {
    return [];
  }
  const ignorable: IpaType[] = [];
  for (let j = 0; j < length; j++) {
    if (ignore(ipa[i + j])) {
      ignorable.push(ipa[i + j]);
      length++; // need to loop an extra time
    }
  }
  return ignorable;
}
